import React from 'react';
import {ContainedButton} from '../ContainedButton';

export class SubmitButton extends ContainedButton {

    render = () => {
        return (
            <input {...this.props} type="submit"/>
        );
    };
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/components/SubmitButton/SubmitButton.jsx